import { __awaiter, __generator } from "tslib";
import { DEFAULT_LS_ACCESS_TOKEN_KEY, DEFAULT_LS_EXCHANGE_TOKEN_KEY, DEFAULT_LS_REFRESH_TOKEN_KEY, } from '../const/local-storage';
var LocalApiCredentials = /** @class */ (function () {
    function LocalApiCredentials(options) {
        this.delegateUser = null;
        this.delegateCompany = null;
        this.exchangeTokenKey = DEFAULT_LS_EXCHANGE_TOKEN_KEY;
        this.accessTokenKey = DEFAULT_LS_ACCESS_TOKEN_KEY;
        this.refreshTokenKey = DEFAULT_LS_REFRESH_TOKEN_KEY;
        this.exchangeTokenKey = (options === null || options === void 0 ? void 0 : options.exchangeTokenKey) || '__EXCHANGE__TOKEN__';
        this.accessTokenKey = (options === null || options === void 0 ? void 0 : options.accessTokenKey) || '__AUTH__TOKEN__';
        this.refreshTokenKey = (options === null || options === void 0 ? void 0 : options.refreshTokenKey) || '__AUTH__REFRESH__TOKEN__';
    }
    LocalApiCredentials.prototype.getTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, accessToken, refreshToken, exchangeToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getAccessToken(),
                            this.getRefreshToken(),
                            this.getExchangeToken(),
                        ])];
                    case 1:
                        _a = _b.sent(), accessToken = _a[0], refreshToken = _a[1], exchangeToken = _a[2];
                        return [2 /*return*/, { accessToken: accessToken, refreshToken: refreshToken, exchangeToken: exchangeToken }];
                }
            });
        });
    };
    LocalApiCredentials.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, localStorage.getItem(this.accessTokenKey)];
            });
        });
    };
    LocalApiCredentials.prototype.getRefreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, localStorage.getItem(this.refreshTokenKey)];
            });
        });
    };
    LocalApiCredentials.prototype.getExchangeToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, localStorage.getItem(this.exchangeTokenKey)];
            });
        });
    };
    LocalApiCredentials.prototype.setDelegateCompany = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.delegateCompany = id || null;
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.getDelegateCompany = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.delegateCompany || null];
            });
        });
    };
    LocalApiCredentials.prototype.setDelegateUser = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.delegateUser = email || null;
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.getDelegateUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.delegateUser || null];
            });
        });
    };
    LocalApiCredentials.prototype.setTokens = function (token, refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = Promise).all;
                        return [4 /*yield*/, this.setAccessToken(token)];
                    case 1:
                        _c = [_d.sent()];
                        return [4 /*yield*/, this.setRefreshToken(refreshToken)];
                    case 2: return [4 /*yield*/, _b.apply(_a, [_c.concat([_d.sent()])])];
                    case 3:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalApiCredentials.prototype.setAccessToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.setItem(this.accessTokenKey, token);
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.setRefreshToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.setItem(this.refreshTokenKey, token);
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.setExchangeToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.setItem(this.exchangeTokenKey, token);
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.deleteTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.deleteAccessToken(), this.deleteRefreshToken(), this.deleteExchangeToken()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalApiCredentials.prototype.deleteAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.removeItem(this.accessTokenKey);
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.deleteRefreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.removeItem(this.refreshTokenKey);
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.deleteExchangeToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.removeItem(this.exchangeTokenKey);
                return [2 /*return*/];
            });
        });
    };
    LocalApiCredentials.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.setDelegateUser(null), this.setDelegateCompany(null), this.deleteTokens()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return LocalApiCredentials;
}());
export { LocalApiCredentials };
